var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4d4f5c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.5,0,11,6H0Z",
    transform: "translate(11 6) rotate(180)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBig);
export default __webpack_public_path__ + "static/media/arrow-down-big.e9df245c5609cbf942befc32e463a603.svg";
export { ForwardRef as ReactComponent };